export default __webpack_public_path__ + "static/media/343.ca322d18.png";